const apiCall = (link) => fetch(link).then(resp => resp.json())

export default apiCall